
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './App.css';
import { BrowserRouter, Routes,Route} from 'react-router-dom';
import QrManuPage from './Components/Qrmenu/QrManuPage';
import Welcome from './Components/Welcome/Welcome';
import QrCartItems from './Components/QrCart/QrCartItems';
import Feedback from './Components/Feedback/Feedback';
import OutletData from './Components/OutletData/OutletData';
import Review from './Components/Reviews/Review';
import AboutUs from './Components/AboutUs/AboutUs';
import RegCustomer from './Components/RegCustomer/RegCustomer';
import Login from './Components/Login/Login';
import CustomerAddress from './Components/CustomerAddress/CustomerAddress';
import MyOrders from './Components/MyOrders/MyOrders';
import CustomerAddressUpdate from './Components/CustomerAddress/CustomerAddressUpdate';
import QrCardItemsParcel from './Components/QrCart/QrCardItemsParcel';
import QrCardItemsTableNo from './Components/QrCart/QrCardItemsTableNo';
import QrCardItemsQuickParcel from './Components/QrCart/QrCardItemsQuickParcel';



function App() {
  return (
    <>
    
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/QrMenuPage" element={<QrManuPage />} />
          <Route path="/QrCartItems" element={<QrCartItems />} />
          <Route path="/Feedback" element={<Feedback/>} />
          <Route path="/Outletdata" element={<OutletData/>} />
          <Route path="/Review" element={<Review/>} />
          <Route path="/AboutUs" element={<AboutUs/>} />
          <Route path="/RegCustomer" element={<RegCustomer/>} />
          <Route path="/Login" element={<Login/>} />
          <Route path="/CustomerAddress" element={<CustomerAddress/>} />
          <Route path="/AddressUpdate" element={<CustomerAddressUpdate/>} />
          <Route path="/MyOrders" element={<MyOrders/>} />
          <Route path="/QrCartItemsGuestHouseParcel" element={<QrCardItemsParcel/>} />
          <Route path="/QrCartItemsTableNo" element={<QrCardItemsTableNo/>} />
          <Route path="/QrCartItemsQuickParcel" element={<QrCardItemsQuickParcel/>} />

        </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
